import type { Invoice, OwnedVehicle, OwnedVehicleDetail } from '@sirius/contracts';

import { request, upload } from '../client';

export const listMyVehicles = (): Promise<OwnedVehicle[]> => request<OwnedVehicle[]>('/my-vehicles');

export const getMyVehicle = (id: string): Promise<OwnedVehicleDetail> =>
	request<OwnedVehicleDetail>(`/my-vehicles/${encodeURIComponent(id)}`);

export const listMyInvoices = (): Promise<Invoice[]> => request<Invoice[]>('/invoices');

/** Підтвердження платежу: PDF або зображення до 10 МБ, необовʼязкова нотатка. */
export const submitPaymentConfirmation = (invoiceId: string, file: File, note: string): Promise<Invoice> => {
	const form = new FormData();
	form.append('file', file);
	if (note.trim()) form.append('note', note.trim());
	return upload<Invoice>(`/invoices/${encodeURIComponent(invoiceId)}/payment-confirmation`, form);
};
